import { ReactNode } from "react"
import cn from "classnames"

import style from "./style.module.scss"

import { PageHeader } from "components/Header/PageHeader"
import { Footer } from "components"

interface Props {
    children: ReactNode
    withSpinner?: boolean
    step?: {
        active: number
        count: number
        prevPage: () => void
        buttonText: string
    }
}

export function PageWrapper({ children, withSpinner, step }: Props) {
    return (
        <>
            <PageHeader
                step={
                    step
                        ? {
                              current: step.active,
                              total: step.count,
                              previous: step.prevPage,
                              buttonText: step.buttonText,
                          }
                        : undefined
                }
            />
            <div
                className={cn(style.container, {
                    [style.withSpinner]: withSpinner,
                })}
            >
                <div className={style.inner}>{children}</div>
            </div>
            <Footer className={style.footer} />
        </>
    )
}
